import { Reducer } from "redux";

import { NtuPatientResponse } from "../models/api/Referral";
import { NtuPatientDispatchTypes } from "../models/dispatchTypes/Referral";
import { PostNtuPatientActionDispatchTypes } from "../constants/HomePage";


const initialState: NtuPatientResponse = {
  loading: false,
  response: false,
  error: null,
};

const PostNtuPatientReducer: Reducer<
  NtuPatientResponse,
  NtuPatientDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case PostNtuPatientActionDispatchTypes.POST_NTU_PATIENT_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case PostNtuPatientActionDispatchTypes.POST_NTU_PATIENT_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case PostNtuPatientActionDispatchTypes.POST_NTU_PATIENT_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
  }
  return state;
};

export default PostNtuPatientReducer;
